import { Injectable } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ThemeManagerService {

  constructor(private readonly primeng: PrimeNG) {
        this.primeng.setTranslation({
            // Españolización del Calendario
            monthNames:	[
                'Enero', 
                'Febrero', 
                'Marzo', 
                'Abril', 
                'Mayo', 
                'Junio', 
                'Julio', 
                'Agosto', 
                'Septiembre', 
                'Octubre', 
                'Noviembre', 
                'Diciembre'
            ],
            monthNamesShort: ['En', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
            dayNamesShort: ['Dom', 'Lu', 'Mar', 'Mier', 'Juev', 'Vier', 'Sab'],
            dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S']
        });
  }

  configureTheme() {
    this.primeng.theme.set({
      preset: Aura,
      options: {
        prefix: 'p',
        darkModeSelector: 'light',
        cssLayer: false
      }
    });

    this.setCssVariables();
  }

  private setCssVariables(): void {
    const root = document.documentElement;

    const colors: Record<string, { primary: string; secondary: string }> = {
      fitosgest: { primary: '#2783c6', secondary: '#4664a8' },
      cropgest: { primary: '#001F5B', secondary: 'rgb(4, 18, 46)' },
      gardengest: { primary: '#c39a6b', secondary: '#d39a6b' },
      agrogest: { primary: '#FFA63B', secondary: '#e28824' },
      purple: { primary: '#a349a4', secondary: '#681a69' },
    };

    const appType = environment.features.applicationType;
    const colorSet = colors[appType] ?? { primary: '#e21f4c', secondary: '#d61b47' };

    root.style.setProperty('--color_primary', colorSet.primary);
    root.style.setProperty('--color_secondary', colorSet.secondary);
    root.style.setProperty('--color_active', 'white');
  }
}
